module.exports = __webpack_public_path__ + "activities_fg.03c6ca283bfe831c0904cd8105dc18f0.png";